import AnimatedCheckmark from '../AnimatedCheckmark'
import { SText, SView } from '../scaled'

interface Props {
  show: boolean
}

export default function FormDone({ show }: Props) {
  return (
    <SView flex={1} align="center" justify="center" gap={32}>
      <AnimatedCheckmark size={200} checked={show} />
      <SText fontSize={32} fontWeight="bold">
        Generating Your Experience
      </SText>
    </SView>
  )
}
